import React, { Fragment } from 'react';
import { v4 as uuidv4 } from 'uuid';

interface IFormattedTextForTranslation {
	index: number;
	isTranslatable: boolean;
	part: string;
	stringParts: string[];
}

export default function FormattedTextForTranslation({
	index,
	isTranslatable,
	part,
	stringParts,
}: IFormattedTextForTranslation) {
	return (
		<Fragment key={uuidv4()}>
			<span className={isTranslatable ? '' : 'notranslate'}>{part}</span>
			{/* Add space after all but the last word */}
			{index < stringParts.length - 1 && ' '}
		</Fragment>
	);
}
